<template>
  <div class="trainingCreate">
    <SOSlotBase :container-name="'trainingCreate'" :loading="isLoading">
      <template v-slot:title-bar>
        <SOTitleBar :page-title="'Pilih Program'" :type="'back'" @back="back" />
      </template>

      <template v-slot:content>
        <br />
        <div class="p-x-20">
          <div class="f-18 f-bold">
            <p>Informasi Training</p>
          </div>
          <div class="form-field d-grid-1">
            <form class="training">
              <div class="form-group">
                <div class="p-t-20">
                  <label class="f-regular f-16 f-c-midgrey remove-margin"
                    >Nama Program</label
                  >
                  <input
                    type="text"
                    class="form-control inputs"
                    id="text_field"
                    aria-describedby="emailHelp"
                    :value="detailJenisTraining.nama"
                    readonly
                    style="color: black; width: 100%"
                  />

                  <template v-if="paramjenis != 'paid_online'">
                    <FormInputJadwal
                      :label="'Pilih Jadwal 1'"
                      :idjenis="paramjenis"
                      :sesi="1"
                    />
                  </template>

                  <template v-if="paramjenis == 'paid_online'">
                    <template
                      v-for="(jadwal, index) in formJadwal.jadwal_training"
                    >
                      <FormInputJadwal
                        :label="'Pilih Jadwal ' + (index + 1)"
                        :idjenis="paramjenis"
                        :sesi="index + 1"
                        :key="index"
                      />
                    </template>
                  </template>

                  <br />
                  <div class="f-18 f-bold">
                    <p>Informasi User</p>
                  </div>

                  <SOInputRegular
                    :title="'Nama Owner'"
                    :validation="'alphanumeric'"
                    :required="true"
                    v-model="formCreate.nama"
                  />
                  <br />
                  <template>
                    <div class="form-group">
                      <SOInputTelp
                        id="edit-wa"
                        title="Nomor Whatsapp"
                        :required="true"
                        :country-code="'62'"
                        placeholder="8123456789"
                        :value="formCreate.telp"
                        @input="onInput"
                        @country-code="setCountryCode"
                      />
                      <ErrorMessage
                        class="error"
                        label="Nomor Whatsapp"
                        :validation="$v.formCreate.telp"
                      />

                      <!--                        <vue-country-code-->
                      <!--                          :preferredCountries="['id', 'my', 'bn']"-->
                      <!--                        >-->
                      <!--                        </vue-country-code>-->
                      <!--                        <input-->
                      <!--                          type="tel"-->
                      <!--                          class="form-control inputs"-->
                      <!--                          id="telpown"-->
                      <!--                          v-model="dataOwner.telp"-->
                      <!--                          placeholder="87171230419"-->
                      <!--                        />-->
                    </div>
                    <button
                      class="btn btn-primary btn-long"
                      :disabled="isButtonDisabled"
                      @click="handleButtonClick"
                    >
                      Lanjutkan
                    </button>
                  </template>
                </div>
              </div>
            </form>
          </div>
        </div>
      </template>
    </SOSlotBase>
  </div>
</template>

<script>
import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOInputRegular from "@/so-components/global/input/SOInputRegular";
import SOInputTelp from "@/so-components/global/input/SOInputTelp.vue";
import FormInputJadwal from "../components/FormInputJadwal";
import ErrorMessage from "@/component-items/ErrorMessage";
import { mapActions, mapGetters } from "vuex";
import { moduleName } from "../store/state";
import { minLength, required } from "vuelidate/lib/validators";

export default {
  name: "TrainingCreate",
  components: {
    SOSlotBase,
    SOTitleBar,
    SOInputRegular,
    SOInputTelp,
    FormInputJadwal,
    ErrorMessage,
  },
  data() {
    return {
      isLoading: false,
      edittelp: "",
      paramjenis: this.$route.params.idjenis,
      formCreate: {
        telp: "",
        country_code: "62",
        nama: "",
      },
    };
  },
  async mounted() {
    await this.init();
  },
  computed: {
    ...mapGetters(moduleName, {
      dataOwner: "detailOwner",
      dataListTraining: "dataJenisTraining",
      detailJenisTraining: "detailJenisTraining",
      formJadwal: "formJadwal",
    }),
    isButtonDisabled() {
      if (this.paramjenis == "paid_online") {
        const jadwalSesi1 = this.formJadwal.jadwal_training[0];
        const jadwalSesi2 = this.formJadwal.jadwal_training[1];
        const isSesi1Updated = jadwalSesi1 && jadwalSesi1.jadwal_mulai;
        const isSesi2Updated = jadwalSesi2 && jadwalSesi2.jadwal_mulai;

        const isRequiredFieldsNotEmpty =
          this.formCreate.nama && this.formCreate.telp;

        return !(isSesi1Updated && isSesi2Updated && isRequiredFieldsNotEmpty);
      }
      if (this.paramjenis != "paid_online") {
        const jadwalSesi1 = this.formJadwal.jadwal_training[0];
        const isSesi1Updated = jadwalSesi1 && jadwalSesi1.jadwal_mulai;

        const isRequiredFieldsNotEmpty =
          this.formCreate.nama && this.formCreate.telp;

        return !(isSesi1Updated && isRequiredFieldsNotEmpty);
      }
    },
  },
  methods: {
    ...mapActions({
      getDetailOwner: `${moduleName}/getDetailOwner`,
      getListJenisTraining: `${moduleName}/getListJenisTraining`,
      getDetailJenisTraining: `${moduleName}/getDetailJenisTraining`,
    }),

    async init() {
      await this.getDetailOwner();
      await this.getListJenisTraining();
      await this.getDetailJenisTraining(this.paramjenis);
      this.formCreate.telp = this.dataOwner.telp;
      this.formCreate.nama = this.dataOwner.nama;
    },
    back() {
      this.$store.dispatch(`kampusModule/resetState`);
      this.$router.push({ name: "training.list" });
    },

    handleButtonClick() {
      this.formJadwal.id_jenis_training = this.paramjenis;
      this.formJadwal.nama_owner = this.formCreate.nama;
      this.formJadwal.no_telp =
        this.formCreate.country_code + "" + this.formCreate.telp;
      this.$router.push({
        name: "informasi.pendaftaran",
        params: { idjenis: this.paramjenis },
      });
    },
    onInput(val) {
      this.formCreate.telp = val;
    },
    setCountryCode(val) {
      this.formCreate.country_code = val;
    },
  },

  validations: {
    formCreate: {
      telp: {
        required,
        minLength: minLength(8),
      },
    },
  },
};
</script>

<style scoped>
.belajar-bersama-smartlink .separator {
  width: unset;
}
.d-flex-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.text-container {
  display: flex;
}

.card {
  padding: 16px;
}
.text-blue {
  color: #206cff;
}

.divider-line {
  display: flex;
  width: 320px;
  height: 4px;
  padding: 2px 0;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
}
.icon-container {
  align-items: end;
}
/*
    .btn-disabled {
      background-color: #ccc;
      color: #f6f6f6;
    } */
</style>
